export function initTabs() {
	const tabTriggers = document.querySelectorAll('.tab-trigger');
	const tabPanes = document.querySelectorAll('.tab-pane');

	if (!tabTriggers.length || !tabPanes.length) return;

	tabTriggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			const targetId = trigger.getAttribute('data-tab-target');
			if (!targetId) return;

			// Handle trigger states
			tabTriggers.forEach((t) => t.setAttribute('aria-selected', 'false'));
			trigger.setAttribute('aria-selected', 'true');

			// Handle pane visibility
			tabPanes.forEach((pane) => {
				pane.classList.add('hidden');
			});

			const targetPane = document.getElementById(targetId);
			if (targetPane) {
				targetPane.classList.remove('hidden');
			}
		});
	});
}
